<template>
    <LoginHeader>
        <p class="text-center mb-10 text-2xl font-bold">Registration for New User</p>
        <div class="login-form">

            <div class="left-side text-left">

                <form @submit.prevent="otpSent ? validateOtp() : sendOtp()">
                    <div class="form-group">
                        <label for="username">Mobile Number:</label>
                        <input type="text" id="mobile" placeholder="Enter your 10 digit mobile number" v-model="mobile"
                            required />
                    </div>
                    <div class="form-group">
                        <label for="acno">Customer ID (ACNO):</label>
                        <input type="text" id="acno" placeholder="Enter your ACNO" v-model="acnoString" required />
                    </div>
                    <div class="form-group" v-if="otpSent">
                        <label for="password">OTP:</label>
                        <OtpInput :otpLength="6" @updateOtp="otp = $event" />
                        <p class="text-right mt-4 text-sm text-blue-600 cursor-pointer hover:underline"
                            @click="resendOtp"
                            :class="{ 'opacity-50 cursor-not-allowed': loadingButton === 'resendOtp' }">
                            <span v-if="loadingButton === 'resendOtp'">Resending...</span>
                            <span v-else>Resend OTP</span>
                        </p>
                    </div>
                    <div class="form-group" v-if="otpSent">
                        <label for="username">Create Password:</label>
                        <input type="password" id="password" placeholder="Enter your 10 digit mobile number"
                            v-model="password" required />
                    </div>
                    <div class="form-group">
                        <div id="recaptcha-container"></div>
                    </div>
                    <p v-if="errorMessages" class="text-red-500 mt-2">{{ errorMessages }}</p>
                    <p v-if="successMessage" class="text-green-500 mt-2">{{ successMessage }}</p>
                    <button type="submit" class="bg-primary rounded">{{ otpSent ? 'Validate OTP' : 'Send OTP'
                        }}</button>
                </form>
            </div>

            <div class="divider"></div>

            <div class="right-side">
                <div>
                    <div class="text-2xl text-center text-gray-400"><span>Existing User</span></div>
                    <p class="mx-5 mt-2">
                        <router-link to="/" class="text-blue-500 hover:text-blue-700">Login</router-link> if you
                        already have an account.
                    </p>
                </div>
                <div class="mt-10 mx-5 text-left">
                    <div class="font-bold"><span>We have added a host of new features!</span></div>
                    <p class="text-base">You can now do so much more:</p>
                    <ul class="list-disc pl-5 text-base ml-0 text-sm">
                        <li>Anywhere access through Desktop of Mobile</li>
                        <li>Enchanced security measures</li>
                    </ul>
                </div>

                <!-- <p><router-link to="/register">Don't have an account? Register here</router-link></p> -->
            </div>
        </div>
    </LoginHeader>
</template>

<script>
import LoginHeader from "@/components/LoginHeader.vue";
import axios from "axios";
import OtpInput from "@/components/OtpInput.vue";

/* global grecaptcha */

export default {
    name: "UserRegister",
    components: {
        LoginHeader, OtpInput
    },
    data() {
        return {
            mobile: '',
            password: '',
            acnoString: '',
            otp: '',
            otpSent: false,
            errorMessages: '',
            successMessage: '',
            recaptchaWidgetId: null,
            recaptchaSiteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
        }
    },
    computed: {
        acno() {
            return parseInt(this.acnoString, 10);
        }
    },
    watch: {
        otpSent(newVal) {
            if (newVal) {
                this.renderRecaptcha();
            }
        }
    },

    methods: {
        renderRecaptcha() {
            const check = () => {
                if (window.grecaptcha && this.recaptchaSiteKey) {
                    this.recaptchaWidgetId = window.grecaptcha.render("recaptcha-container", {
                        sitekey: this.recaptchaSiteKey,
                    });
                } else {
                    setTimeout(check, 3000);
                }
            };
            check();
        },

        async sendOtp() {
            this.errorMessages = '';

            if (!this.mobile || this.mobile.length !== 10) {
                this.showError('Enter a valid 10-digit Mobile number');
                return;
            }

            if (!this.acno) {
                this.showError("Enter your Customer ID (ACNO)");
                return;
            }

            try {
                const response = await axios.post('https://api-netbanking.dmcbank.co.in/customer_check', {
                // const response = await axios.post('http://127.0.0.1:8083/customer_check', {
                    mobile: this.mobile,
                    acno: this.acno
                });

                if (response.data.status === 'success') {
                    this.otpSent = true;
                } else {
                    this.showError(response.data.message || 'Failed to send OTP');
                }

            } catch (error) {
                const errorMessage = error.response && error.response.data && error.response.data.status === 'failure'
                    ? error.response.data.message
                    : 'Error sending OTP: ' + error.message;
                this.showError(errorMessage);
            }

        },
        async validateOtp() {
            this.errorMessages = '';
            // const otp = this.otpArray.join('');

            const recaptchaResponse = grecaptcha.getResponse(this.recaptchaWidgetId);

            if (!recaptchaResponse) {
                this.showError("Please complete the CAPTCHA");
                return;
            }

            if (this.otp.length !== 6) {
                this.showError('Enter a valid 6-digit OTP');
                return;
            }

            try {
                const response = await axios.post('https://api-netbanking.dmcbank.co.in/customer_otp', {
                // const response = await axios.post('http://127.0.0.1:8083/customer_otp', {
                    mobile: this.mobile,
                    acno: this.acno,
                    otp: this.otp,
                    password: this.password,
                    recaptchaToken: recaptchaResponse
                });

                if (response.data.status === 'success') {
                    this.successMessage = "Registration completed. Please login with username and password."
                    setTimeout(() => {
                        this.$router.push('/');
                    }, 3000);
                } else {
                    this.showError(response.data.message || 'Failed to send OTP');
                }

            } catch (error) {
                const errorMessage = error.response && error.response.data && error.response.data.status === 'failure'
                    ? error.response.data.message
                    : 'Error sending OTP: ' + error.message;
                this.showError(errorMessage);
            }
        },
        async resendOtp() {
            if (this.loadingButton) return;
            this.loadingButton = 'resendOtp';

            try {
                const response = await axios.post('https://api-netbanking.dmcbank.co.in/resend-otp', {
                // const response = await axios.post('http://127.0.0.1:8083/resend-otp', {
                    mobile: this.mobile,
                    context: 'registration'
                });

                if (response.data.status === 'success') {
                    this.successMessage = 'OTP resent successfully';
                    setTimeout(() => { this.successMessage = ''; }, 3000);
                } else {
                    this.showError(response.data.message || 'Failed to resend OTP');
                }
            } catch (error) {
                this.showError(error.response?.data?.message || 'Error resending OTP');
            } finally {
                this.loadingButton = null;
            }
        },
        moveToNext(index, event) {
            if (event.target.value && index < 5) {
                this.$refs.otpInputs[index + 1].focus();
            }
        },
        moveToPrev(index, event) {
            if (!event.target.value && index > 0) {
                this.$refs.otpInputs[index - 1].focus();
            }
        },
        showError(message) {
            this.errorMessages = message;
            if (this.errorTimeout) {
                clearTimeout(this.errorTimeout);
            }
            this.errorTimeout = setTimeout(() => {
                this.errorMessages = '';
            }, 3000);
        },
    },
};

</script>

<style scoped>
.otp-container {
    display: flex;
    justify-content: space-between;
    gap: 5px;
}

.otp-box {
    width: 40px;
    height: 40px;
    font-size: 20px;
    text-align: center;
    border: 1px solid #ccc;
    border-radius: 4px;
    /* margin-right: 5px; */
}

.login-form {
    display: flex;
    justify-content: space-between;
}

.left-side,
.right-side {
    width: 48%;
}

.left-side h2 {
    margin-bottom: 20px;
}

.form-group {
    margin-bottom: 15px;
}

.form-group label {
    display: block;
}

.form-group input {
    width: 100%;
    padding: 8px;
    margin-top: 5px;
    border: 1px solid #ccc;
    border-radius: 4px;
}

button {
    width: 100%;
    padding: 10px;
    /* background-color: #4CAF50; */
    color: white;
    border: none;
    cursor: pointer;
}

/* button:hover {
    background-color: #45a049;
  } */

.divider {
    width: 1px;
    background-color: #ddd;
    margin: 0 20px;
}

.right-side p {
    font-size: 14px;
}

.right-side a {
    color: #007BFF;
}

.right-side a:hover {
    text-decoration: underline;
}
</style>
